import { handleResponse, authHeader } from '../helpers';

const BASE_URL = process.env.REACT_APP_API_URL;

export const queueService = {
    getCallQueue,
    getPipedriveUsers,
    getCampaignUsers,
    saveCampaignUsers,
    getCallStats,
    getChatStats,
    getCallAttemptData,
};

function getCallAttemptData(start, end) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/report/callAttempts?start=${start}&end=${end}` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function getCallStats(start) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/report/callStats?start=${start}` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function getChatStats(start) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/report/chatStats?start=${start}` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function getCallQueue() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/call/queue/list/all` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function getPipedriveUsers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/info/pipedrive-users` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function getCampaignUsers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}/info/campaign-users` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}

function saveCampaignUsers(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}/info/campaign-users` , requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error(err)
        });
}
